import { useSearchParams, Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button, Card } from '../components/ui';

export function PaymentFailPage() {
  const [params] = useSearchParams();
  const invoiceId = params.get('InvId');
  return (
    <div className="min-h-screen p-6 max-w-lg mx-auto flex flex-col items-center justify-center text-center safe-top safe-bottom">
      <Card variant="elevated" padding="lg" className="w-full">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-red-100 text-red-600 mb-4">
          <XCircle size={32} />
        </div>
        <h1 className="text-xl font-bold mb-2">Оплата не прошла</h1>
        <p className="text-sm text-tg-hint mb-6">
          Платёж был отменён или произошла ошибка. Если деньги списались — они вернутся в течение
          нескольких дней.
          {invoiceId && <span className="block mt-2">Инвойс #{invoiceId}</span>}
        </p>
        <div className="flex flex-col gap-2">
          <Link to="/balance">
            <Button variant="primary" className="w-full">
              Попробовать ещё раз
            </Button>
          </Link>
          <Link to="/">
            <Button variant="ghost" className="w-full">
              На главную
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
}
